// Attendance Status Enum
export const AttendanceStatusEnum = Object.freeze({
  Incomplete: 0,
  Present: 1,
  HalfDay: 2,
  ShortTime: 3,
  Absent: 4,
  OnLeave: 5,
  Weekend: 6,
  Holiday: 7,
  Overtime: 8,
});

export const AttendenceStatusLabel = Object.freeze({
  [AttendanceStatusEnum.Incomplete]: "Incomplete",
  [AttendanceStatusEnum.Present]: "Present",
  [AttendanceStatusEnum.HalfDay]: "Half Day",
  [AttendanceStatusEnum.ShortTime]: "Short Time",
  [AttendanceStatusEnum.Absent]: "Absent",
  [AttendanceStatusEnum.OnLeave]: "On Leave",
  [AttendanceStatusEnum.Weekend]: "Weekend",
  [AttendanceStatusEnum.Holiday]: "Holiday",
  [AttendanceStatusEnum.Overtime]: "Over Time",
});

// Professional Elevated Status Config
export const STATUS_CONFIG = {
  [AttendanceStatusEnum.Incomplete]: {
    name: "Incomplete",
    class: "status-incomplete",
    short: "INCOMP",
    color: "#ef6c00", // Prof. Orange (Matches your .late-icon)
    backgroundColor: "rgba(239, 108, 0, 0.1)",
    icon: "⏳",
    badge: "warning",
  },
  [AttendanceStatusEnum.Present]: {
    name: "Present",
    class: "status-present",
    short: "PRESENT",
    color: "#206d1a", // var(--text-main)
    backgroundColor: "#ebfec6", // var(--light-main)
    icon: "check",
    badge: "success",
  },
  [AttendanceStatusEnum.HalfDay]: {
    name: "Half Day",
    class: "status-halfday",
    short: "HALF",
    color: "#7bad67", // var(--secondary-main)
    backgroundColor: "rgba(123, 173, 103, 0.12)",
    icon: "½",
    badge: "default",
  },
  [AttendanceStatusEnum.ShortTime]: {
    name: "Short Time",
    class: "status-shorttime",
    short: "SHORT",
    color: "#00796b", // Deep Teal
    backgroundColor: "#e0f2f1",
    icon: "⏱️",
    badge: "warning",
  },
  [AttendanceStatusEnum.Absent]: {
    name: "Absent",
    class: "status-absent",
    short: "ABSENT",
    color: "#bd0000", // Your alert-error text
    backgroundColor: "#fc979720", // Muted Error Red
    icon: "❌",
    badge: "error",
  },
  [AttendanceStatusEnum.OnLeave]: {
    name: "On Leave",
    class: "status-onleave",
    short: "LEAVE",
    color: "#00838f", // Professional Teal
    backgroundColor: "#e0f7fa",
    icon: "🏖️",
    badge: "processing",
  },
  [AttendanceStatusEnum.Weekend]: {
    name: "Weekend",
    class: "status-weekend",
    short: "WEEKEND",
    color: "#64748b", // var(--text-secondary)
    backgroundColor: "#f1f5f9",
    icon: "📅",
    badge: "default",
  },
  [AttendanceStatusEnum.Holiday]: {
    name: "Holiday",
    class: "status-holiday",
    short: "HOLIDAY",
    color: "#6a1b9a", // Deep Professional Purple
    backgroundColor: "#f3e5f5",
    icon: "🎉",
    badge: "success",
  },
  [AttendanceStatusEnum.Overtime]: {
    name: "Over Time",
    class: "status-overtime",
    short: "OT",
    color: "#2e7d32", // Success Green
    backgroundColor: "#e8f5e9",
    icon: "⚡",
    badge: "success",
  },
};